import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPaperclip = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.76634 11.3313C7.36634 12.7313 5.17884 12.7313 3.77884 11.3313C2.37884 9.93125 2.29134 7.83125 3.69134 6.51875L7.62884 2.58125C8.50384 1.70625 9.90384 1.70625 10.6913 2.58125C11.5663 3.45625 11.5663 4.85625 10.6913 5.64375L7.62884 8.79375C7.27884 9.14375 6.75384 9.14375 6.40384 8.79375C6.05384 8.44375 6.05384 7.91875 6.40384 7.56875L8.85384 5.11875L7.54134 3.89375L5.17884 6.25625C4.12884 7.30625 4.12884 8.96875 5.17884 9.93125C6.22884 10.8938 7.89134 10.9813 8.85384 9.93125L12.0038 6.78125C13.5788 5.20625 13.5788 2.75625 12.0038 1.18125C10.4288 -0.39375 7.97884 -0.39375 6.40384 1.18125L2.46634 5.29375C0.453838 7.30625 0.541338 10.5437 2.55384 12.5563C3.60384 13.6063 4.91634 14.1313 6.31634 14.1313C7.71634 14.1313 9.02884 13.6063 9.99134 12.5563L13.7538 8.79375L12.5288 7.56875L8.76634 11.3313Z",
		fill: "currentColor"
	})
});
export default SvgIconPaperclip;
